import { MultiplePermissions } from '../types';

export const FRESH_LOOK_MULTIPLE_PERMISSIONS: MultiplePermissions = [
  ['FreshLook_Table', 'NA', 'Gold_East'],
  ['FreshLook_Table', 'NA', 'Gold_West'],
];
